import type { IEntityPermissions } from "../entity-permissions.interface";

export class AllowAllEntityPermissions implements IEntityPermissions {
  entityName = "UNINITIALIZED";
  isFieldEditable() {
    return true;
  }
  isFieldViewable() {
    return true;
  }
  isAnyFieldEditable() {
    return true;
  }
  isAnyFieldViewable() {
    return true;
  }
}
